import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./agenticDetails.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { generateSimpleBadge } from '~/modules/helpers/badgeHelper';
import { i18nStore, selectI18n } from '~/modules/stores/i18nStore';
import { selectExtensionListing } from '~/modules/utilities/listing_utils';
class AgenticDetails extends LightningElement {
  constructor(...args) {
    super(...args);
    this.listing = void 0;
    this.label = void 0;
    this.hasInfoIcon = false;
    this.tooltipData = void 0;
  }
  i18nStoreWire({
    i18n,
    i18nStaticCache
  }) {
    this.i18n = i18nStaticCache;
    this.i18nModule = i18n;
  }
  get extensionListing() {
    return selectExtensionListing(this.listing);
  }
  getCopilotData() {
    const data = this.extensionListing;
    return {
      numAgents: data.numAgents,
      numTopics: data.numTopics,
      numActions: data.numActions
    };
  }
  get agentforceBadges() {
    if (!this.i18nModule?.oaf?.agenticDetails) {
      return [];
    }
    const copilotData = this.getCopilotData();
    if (!copilotData) {
      return [];
    }
    const badges = [];
    const {
      numAgents,
      numTopics,
      numActions
    } = copilotData;

    // Agents Badge
    if (typeof numAgents === 'number' && numAgents > 0) {
      const agentsLabel = this.i18nModule.oaf.agenticDetails.agents({
        numAgents: numAgents.toString()
      });
      badges.push(generateSimpleBadge(agentsLabel));
    }

    // Topics Badge
    if (typeof numTopics === 'number' && numTopics > 0) {
      const topicsLabel = this.i18nModule.oaf.agenticDetails.topics({
        numTopics: numTopics.toString()
      });
      badges.push(generateSimpleBadge(topicsLabel));
    }

    // Actions Badge
    if (typeof numActions === 'number' && numActions > 0) {
      const actionsLabel = this.i18nModule.oaf.agenticDetails.actions({
        numActions: numActions.toString()
      });
      badges.push(generateSimpleBadge(actionsLabel));
    }
    return badges;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(AgenticDetails, {
  publicProps: {
    listing: {
      config: 0
    },
    label: {
      config: 0
    },
    hasInfoIcon: {
      config: 0
    },
    tooltipData: {
      config: 0
    }
  },
  wire: {
    i18nStoreWire: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: i18nStore,
          selector: selectI18n
        };
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(AgenticDetails, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;